import React from 'react';
import { MessageCircle } from 'lucide-react';
import { trackFeatureUsage } from '../firebase';

const SupportButton = ({ variant = 'floating' }) => {
  const lineUrl = 'https://lin.ee/9Mgwhzg';

  const handleClick = (e) => {
    e.stopPropagation();
    trackFeatureUsage('action_line_support');
    window.open(lineUrl, '_blank');
  };

  if (variant === 'floating') {
    return (
      <button
        onClick={handleClick}
        className="hidden md:flex fixed bottom-8 right-8 w-14 h-14 bg-[#00B900] outline-none text-white rounded-full items-center justify-center shadow-lg hover:bg-[#009900] hover:scale-110 transition-all duration-300 z-[60] focus:outline-none focus:ring-4 focus:ring-green-300"
        title="ติดต่อสอบถามผ่าน LINE (@portpro)"
      >
        <MessageCircle size={28} className="fill-white/20" />
      </button>
    );
  }

  // Mobile menu variant
  return (
    <button
      onClick={handleClick}
      className="w-full flex items-center justify-center gap-2 px-4 py-3 text-sm font-medium text-[#00B900] dark:text-green-400 hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors"
    >
      <MessageCircle size={16} />
      <span>ติดต่อแอดมิน (LINE)</span>
    </button>
  );
};

export default SupportButton;
